<template>
  <div><SumulaBrowser /></div>
</template>


<script setup>
import SumulaBrowser from "@/components/enunciado/EnunciadoBrowser.vue";
import { useAppStore } from "@/store/app-store";

const appStore = useAppStore();
appStore.drawerExpanded = true;
</script>
